import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
  selector: "app-short-search-nights-dropdown",
  templateUrl: "./short-search-nights-dropdown.component.html",
  styleUrls: ["./short-search-nights-dropdown.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class ShortSearchNightsDropdownComponent {
  @Input() days: number[] = [];
  @Input() nightsFrom: number;
  @Input() nightsTo: number;
  @Input() pendingStartDay: number | null = null;
  @Input() hoveredDay: number | null = null;
  @Input() hint: string;

  @Output() hovered = new EventEmitter<number>();
  @Output() hoverLeft = new EventEmitter<void>();
  @Output() selected = new EventEmitter<number>();

  isNightActive(day: number) {
    const { from, to } = this.getDisplayedNightRange();
    return day >= from && day <= to;
  }

  isNightRangeStart(day: number) {
    const { from, hasRange } = this.getDisplayedNightRange();
    return hasRange && day === from;
  }

  isNightRangeEnd(day: number) {
    const { to, hasRange } = this.getDisplayedNightRange();
    return hasRange && day === to;
  }

  isNightInRange(day: number) {
    const { from, to, hasRange } = this.getDisplayedNightRange();
    if (!hasRange) {
      return false;
    }

    return day > from && day < to;
  }

  private getDisplayedNightRange() {
    if (this.pendingStartDay !== null && this.hoveredDay !== null && this.hoveredDay !== this.pendingStartDay) {
      return {
        from: Math.min(this.pendingStartDay, this.hoveredDay),
        to: Math.max(this.pendingStartDay, this.hoveredDay),
        hasRange: true,
      };
    }

    const from = Math.min(this.nightsFrom + 1, this.nightsTo + 1);
    const to = Math.max(this.nightsFrom + 1, this.nightsTo + 1);

    return {
      from,
      to,
      hasRange: from !== to,
    };
  }
}
